import React from 'react';

import styled from '@emotion/styled';
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import * as breakpoint from '../../../styles/breakpoints.module.scss';
const Visual = ({ list, currentItem }) => {
  return (<VisualWrapper>
    {list.edges.map((item,index) => {
      if(item.node.visual)
        return <Image className={currentItem === item.node.data.key ? "active" : ""} key={`visual_${item.node.data.key}`}>
          <GatsbyImage key={`visual_${index}`}image={getImage(item.node.visual)} alt="secret guest" objectFit={'cover'}/>
        </Image>
      else
        return <React.Fragment key={`visual_${index}`}></React.Fragment>
    })}
  </VisualWrapper>);
}
 
export default Visual;


const VisualWrapper = styled.div`
  
  overflow:visible;
  position:relative;
  margin-right:24px;
  height:936px;
  width: calc(50% - 48px);

  .left &{
    
    margin-right:0px;
    margin-left:48px;
  }

  @media only screen and (max-width: ${breakpoint.smMax}){
    display:none;
  }
`;

const Image = styled.div`
  position:absolute;
  width:936px;
  height:936px;
  
  right:0;
  top:0;
  border-radius: 0px 6px 6px 0px;
  overflow:hidden;
  z-index:1;

  opacity:0;
  transition: opacity .5s;

  &.active{
    opacity:1;
    z-index:10;
  }


  .gatsby-image-wrapper{
    width:936px;
    height:936px;
  }

  .left &{
    left:0;
    top:0;
    border-radius: 6px 0px 0px 6px;

    
  }

  @media only screen and (max-width: 1919px){
    .gatsby-image-wrapper{
      position:absolute;
      left:calc((50vw - 960px) * -0.5);
    }

    .left &{
      .gatsby-image-wrapper{
        left:auto;
        right: calc((50vw - 960px) * -0.5);
      }
    }

  }
`
